<template>
  <section class="fluent-anti-carton">
    <div class="fluent-anti-carton-sticky">
      <div v-textMotion="50" class="anti-carton-text-intro">
        <p class="title">防卡顿引擎</p>
        <p class="sub-title">指哪打哪，久用不卡</p>
        <p class="description">
          底层技术更加智能、更加懂你。从资源调度、资源挖掘、资源抗老化和异常优化四个方面入手，将系统资源的利用率提高45%，响应速度提高32%，帧率稳定性提高17%。
        </p>
      </div>
      <div class="anti-carton-container">
        <div
          class="anti-carton-container-box wow textInPartMotion"
          data-wow-duration=".7s"
          data-wow-delay="1s"
          :data-wow-offset="100"
        >
          <img ref="bg" v-lazy="require('../../assets/fluent/carton1.jpg')" alt="ColorOS 11" class="anti-carton-img" />
          <p>资源调度</p>
        </div>
        <div
          class="anti-carton-container-box wow textInPartMotion"
          data-wow-duration=".7s"
          data-wow-delay="1.15s"
          :data-wow-offset="100"
        >
          <img ref="bg" v-lazy="require('../../assets/fluent/carton2.jpg')" alt="ColorOS 11" class="anti-carton-img" />
          <p>资源挖掘</p>
        </div>
        <div
          class="anti-carton-container-box wow textInPartMotion"
          data-wow-duration=".7s"
          data-wow-delay="1.3s"
          :data-wow-offset="100"
        >
          <img ref="bg" v-lazy="require('../../assets/fluent/carton3.jpg')" alt="ColorOS 11" class="anti-carton-img" />
          <p>资源抗老化</p>
        </div>
        <div
          class="anti-carton-container-box wow textInPartMotion"
          data-wow-duration=".7s"
          data-wow-delay="1.45s"
          :data-wow-offset="100"
        >
          <img ref="bg" v-lazy="require('../../assets/fluent/carton4.jpg')" alt="ColorOS 11" class="anti-carton-img" />
          <p>异常优化</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      progress: 0
    };
  },
  computed: {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.fluent-anti-carton {
  position: relative;
  z-index: 1;
  .fluent-anti-carton-sticky {
    height: 75vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
  .anti-carton-text-intro {
    max-width: 528px;
    // .title {
    //   font-weight: 500;
    // }
    // .sub-title {
    //   font-size: 36px;
    // }
  }
  .anti-carton-container {
    padding: 12.7vh 0 5.2vh 0;
    display: flex;
    justify-content: center;
    .anti-carton-container-box {
      width: 200px;
      text-align: center;
      img {
        width: 120px;
      }
      p {
        font-size: 16px;
        line-height: 24px;
        padding: 16px 0;
      }
    }
  }
}
@media screen and (max-width: 1100px) {
  .fluent-anti-carton {
    .anti-carton-container {
      .anti-carton-container-box {
        width: 23.2vw;
      }
    }
  }
}
@media screen and (max-width: 734px) {
  .fluent-anti-carton {
    .fluent-anti-carton-sticky {
      background: #f6f6f7;
      height: 50vh;
      min-height: 428px;
      width: 100%;
      padding: 0 21px;
      text-align: left;
      align-items: flex-start;
      box-sizing: border-box;
    }
    .anti-carton-text-intro {
      margin-top: 50px;
      // .title {
      //   font-weight: 500;
      // }
      // .sub-title {
      //   font-size: 24px;
      //   line-height: 30px;
      // }
      // .description {
      //   padding-top: 20px;
      //   font-size: 13px;
      // }
    }
    .anti-carton-container {
      padding-top: 40px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      .anti-carton-container-box {
        width: 17.2vw;
        text-align: center;
        img {
          width: 100%;
          border-radius: 50%;
        }
        p {
          font-size: 12px;
          line-height: 14px;
          padding: 15px 0;
        }
      }
    }
  }
}
</style>
